
import { initPopover } from "@/plugins/bootstrapSetup";
import { Popover } from "bootstrap";
import { MapZoomLevels } from "@/types";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class TheGoogleMapToggleButton extends Vue {
  // ---------- Props ----------

  /** The zoom level of the map (or off) */
  @Prop() mapZoomLevel!: MapZoomLevels;

  /** Show the map only if the lat and lng is not 0 and all fields exist. */
  @Prop() showMap!: boolean;

  // ------- Local Vars --------

  /** Reference to all popovers so we can modify them (Note that in this component, there is only one). */
  popovers!: Popover[];

  // --------- Watchers --------

  @Watch("mapZoomLevel")
  setDynamicHelpMessage(): void {
    // Need to essentially delete and rebuild because otherwise popover content doesn't change
    if (this.popovers) {
      // NOTE: there is only one, but this is for robustness
      this.popovers.forEach((popover) => {
        popover.dispose();
      });
      this.popovers = initPopover(
        this.$refs.googleMapButton as Element,
        this.dynamicHelpMessage
      );
    }
  }
  // ------- Lifecycle ---------

  mounted(): void {
    if (this.$refs.googleMapButton) {
      this.popovers = initPopover(
        this.$refs.googleMapButton as Element,
        this.dynamicHelpMessage
      );
    }
  }
  // --------- Methods ---------

  /** Choose an icon based on the state. */
  get chooseIcon(): string[] {
    switch (this.mapZoomLevel) {
      case MapZoomLevels.CLOSE:
        return ["compass"];
      case MapZoomLevels.FAR:
        return ["map", "slash"];
      default:
        return ["geo-alt"];
    }
  }

  /** Gets the dynamic help message. */
  get dynamicHelpMessage(): string {
    switch (this.mapZoomLevel) {
      case MapZoomLevels.CLOSE:
        return "Show more context.";
      case MapZoomLevels.FAR:
        return "Hide the map.";
      default:
        return "Show camera location on a map.";
    }
  }
}
